import { useRouter } from "next/navigation";
import Button from "@portal/components/atoms/v2/buttons/button";
import { IFooterProps } from "./types";
import { useSession } from "@portal/auth/client/SessionProvider";

export const RobotNavigateToPage = (loggedIn: boolean, pageIndex: number, centerId: string) => {
  const basePath = loggedIn || pageIndex > 12 ? `/robot/authenticated` : `/robot`;
  return pageIndex === 0 ? `${basePath}?centerId=${centerId}` : `${basePath}/${pageIndex}?centerId=${centerId}`;
};

export const RobotFooterComponent = ({
  pageIndex,
  centerId,
  primaryButtonText,
  secondaryButtonText,
  disabled = false,
  onNextClick,
  loading = false,
  secondaryButtonClickOverride,
  primaryButtonClickOverride,
}: IFooterProps) => {
  const router = useRouter();
  const { session } = useSession();
  const isLoggedIn = session?.status === "authenticated";

  async function OnFooterClick(pageIndex: number, centerId: string, primary?: boolean, loggedIn?: boolean) {
    const newPageIndex = primary ? pageIndex + 1 : pageIndex - 1;
    const newUrl = RobotNavigateToPage(loggedIn ?? false, newPageIndex, centerId);

    if (primary && onNextClick) {
      await onNextClick();
      router.push(newUrl);
    } else {
      router.push(newUrl);
    }
  }

  return (
    <div className="flex w-full py-5 px-3 md:px-5 justify-between">
      <Button
        onClick={() => {
          if (secondaryButtonClickOverride) {
            secondaryButtonClickOverride();
          } else {
            OnFooterClick(Number(pageIndex), centerId, false, isLoggedIn);
          }
        }}
        text={secondaryButtonText}
      />
      <Button
        onClick={() => {
          if (primaryButtonClickOverride) {
            primaryButtonClickOverride();
          } else {
            OnFooterClick(Number(pageIndex), centerId, true, isLoggedIn);
          }
        }}
        text={primaryButtonText}
        disabled={disabled}
        primary
        loading={loading ? 1 : 0}
      />
    </div>
  );
};
